import { createApiRef } from '@backstage/core-plugin-api';
import {
  IsItOpenEnvironment,
  IsItOpenHttpRequest,
  IsItOpenMqttRequest,
  IsItOpenResponse,
  IsItOpenTcpRequest,
  RequestOptions,
  TypedResponse,
} from '@internal/backstage-plugin-is-it-open-common';

export const isItOpenApiRef = createApiRef<IsItOpenApi>({
  id: 'plugin.is-it-open.service',
});

export type IsItOpenApi = {
  getIsItOpenEnvironments(
    request: {},
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<IsItOpenEnvironment>>>;
  postIsItOpenCheckHttp(
    request: { body: IsItOpenHttpRequest },
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>>;
  postIsItOpenCheckMqtt(
    request: { body: IsItOpenMqttRequest },
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>>;
  postIsItOpenCheckTcp(
    request: { body: IsItOpenTcpRequest },
    options?: RequestOptions,
  ): Promise<TypedResponse<IsItOpenResponse>>;
};
